import type { ImageArray } from "@pdfking/compatibility"

import { type GUID, UInt8Hash } from "@pdfking/tfunc"

export const ImageHash = (image: ImageArray): Promise<GUID> =>
  UInt8Hash([image.data])
